import React from 'react';
import AppBar from '../components/appBar/AppBar';
import {styled} from '@mui/material/styles';
import {COLORS} from '@fupa/fupa-uikit';
import Footer from '../components/landingPage/footer/Footer';
import Header from '../components/landingPage/Header';
import IntroductionCard from '../components/landingPage/cards/IntroductionCard';
import TestimonialsCard from '../components/landingPage/cards/TestimonialsCard';
import FaqCard from '../components/landingPage/cards/FaqCard';
import SupportCard from '../components/landingPage/cards/SupportCard';
import ClubCard from '../components/landingPage/cards/ClubCard';
import UspsCard from '../components/landingPage/cards/UspsCard';
import SamplesCard from '../components/landingPage/cards/SamplesCard';
import PromoVideoCard from '../components/landingPage/cards/PromoVideoCard';

const Wrapper = styled('div')`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const Content = styled('div')`
  position: relative;
  background-color: ${COLORS.fupaPrimary};
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  z-index: 1;
`;

const LandingPage = () => {
  return (
    <Wrapper>
      <AppBar />
      <Content>
        <Header />
        <UspsCard />
        <PromoVideoCard />
        <ClubCard />
        <IntroductionCard />
        <SamplesCard />
        <TestimonialsCard />
        <FaqCard />
        <SupportCard />
        <Footer />
      </Content>
    </Wrapper>
  );
};

export default LandingPage;
